/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Metadata_Title1Inputs */

const id_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const ms_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const da_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const de_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadaten`)
};

const en_us2_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const es_es2_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatos`)
};

const es_mx2_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatos`)
};

const fil_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const fr_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métadonnées`)
};

const it_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadati`)
};

const hu_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metaadatok`)
};

const nl_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const no_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const pl_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadane`)
};

const pt_br2_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadados`)
};

const pt_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadados`)
};

const ro_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadate`)
};

const fi_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metatiedot`)
};

const sv_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const vi_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siêu dữ liệu`)
};

const tr_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta Veriler`)
};

const cs_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const bg_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метаданни`)
};

const ru_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метаданные`)
};

const uk_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метадані`)
};

const ar_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البيانات الوصفية`)
};

const hi_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा`)
};

const th_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เมทาดาทา`)
};

const ja_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータ`)
};

const zh_cn2_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元数据`)
};

const zh_hant1_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中繼資料`)
};

const ko_offerdetail_metadata_title1 = /** @type {(inputs: Offerdetail_Metadata_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메타데이터`)
};

/**
* | output |
* | --- |
* | "Metadata" |
*
* @param {Offerdetail_Metadata_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_metadata_title1 = /** @type {((inputs?: Offerdetail_Metadata_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Metadata_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_metadata_title1(inputs)
	if (locale === "ms") return ms_offerdetail_metadata_title1(inputs)
	if (locale === "da") return da_offerdetail_metadata_title1(inputs)
	if (locale === "de") return de_offerdetail_metadata_title1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_metadata_title1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_metadata_title1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_metadata_title1(inputs)
	if (locale === "fil") return fil_offerdetail_metadata_title1(inputs)
	if (locale === "fr") return fr_offerdetail_metadata_title1(inputs)
	if (locale === "it") return it_offerdetail_metadata_title1(inputs)
	if (locale === "hu") return hu_offerdetail_metadata_title1(inputs)
	if (locale === "nl") return nl_offerdetail_metadata_title1(inputs)
	if (locale === "no") return no_offerdetail_metadata_title1(inputs)
	if (locale === "pl") return pl_offerdetail_metadata_title1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_metadata_title1(inputs)
	if (locale === "pt") return pt_offerdetail_metadata_title1(inputs)
	if (locale === "ro") return ro_offerdetail_metadata_title1(inputs)
	if (locale === "fi") return fi_offerdetail_metadata_title1(inputs)
	if (locale === "sv") return sv_offerdetail_metadata_title1(inputs)
	if (locale === "vi") return vi_offerdetail_metadata_title1(inputs)
	if (locale === "tr") return tr_offerdetail_metadata_title1(inputs)
	if (locale === "cs") return cs_offerdetail_metadata_title1(inputs)
	if (locale === "bg") return bg_offerdetail_metadata_title1(inputs)
	if (locale === "ru") return ru_offerdetail_metadata_title1(inputs)
	if (locale === "uk") return uk_offerdetail_metadata_title1(inputs)
	if (locale === "ar") return ar_offerdetail_metadata_title1(inputs)
	if (locale === "hi") return hi_offerdetail_metadata_title1(inputs)
	if (locale === "th") return th_offerdetail_metadata_title1(inputs)
	if (locale === "ja") return ja_offerdetail_metadata_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_metadata_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_metadata_title1(inputs)
	return ko_offerdetail_metadata_title1(inputs)
});
export { offerdetail_metadata_title1 as "offerDetail.metadata.title" }